module.exports = __webpack_public_path__ + "img/H15-1.939d15c8.jpg";